angular.module('app.admin.broadcastManager.broadcastManagerService', [])
  .factory('app.admin.broadcastManager.broadcastManagerService', [
    '$http',
    'ADMIN_API_URL',
    function ($http, ADMIN_API_URL) {
      return {
        getLeagues: function () {
          return $http.get(window.location.api('/broadcast_leagues'));
        },
        getTeams: function (league_id) {
          return $http.get(window.location.api('broadcast_teams?league=' + league_id));
        },
        getGames: function (team_id) {
          return $http.get(window.location.api('broadcast_games?team=' + team_id));
        },
        getOverlayModifiers(game_id, audio_id) {
          return $http.get(ADMIN_API_URL + '/broadcastManager/overlay_modifiers/' + game_id + '/' + audio_id);
        },
        getStreams: function (game_id) {
          return $http.get(window.location.api('broadcast_games?team=' + team_id));
        },
        retrieveGame: function (game_id) {
          return $http.get(window.location.api('broadcast/' + game_id));
        },
        retrieveScoringProviders: function () {
          return $http.get(window.location.api('scoring_providers'));
        },
        retrieveLayouts: function (game_id, stream_id) {
          return $http.get(ADMIN_API_URL + '/broadcastManager/overlay_types/' + game_id + '/' + stream_id);
        },
        saveProvider: (game) => {
          return $http.put(
            window.location.api('broadcast/' + game.igameid + '/publish_scoreboard'),
            {
              iscoringproviderid: game.iscoringproviderid,
              iscoringprovidergameid: game.iscoringprovidergameid
            }
          );
        },
        publishScoreboard: (game_id, scoreboard) => {
          return $http.put(window.location.api('broadcast/' + game_id + '/publish_scoreboard'), scoreboard);
        },
        setGameStreamOverlayModifier: (game_id, stream_id, modifier) => {
          return $http.put(ADMIN_API_URL + '/broadcastManager/games/' + game_id + '/overlay_modifier/' + stream_id,
            {
              modifierOn: modifier.isOn,
              modifierId: modifier.id
            });
        },
        setGameStreamPowerPlayClock: (game_id, stream_id, enablePowerPlayClock) => {
          return $http.put(ADMIN_API_URL + '/broadcastManager/games/' + game_id + '/powerplay_clock/' + stream_id,
            {
              enablePowerPlayClock: enablePowerPlayClock
            });
        },
        toggleLiveScoring: (game_id, status) => {
          return $http.put(window.location.api('broadcast/' + game_id + '/publish_scoreboard'),
            {
              uselivescoring: status
            }
          );
        },
        toggleOverlay: (game, stream, enable, sponsor_id) => {
          return $http.put(window.location.api('broadcast/' + game.igameid + '/overlay/' + stream.iaudiostreamid_fk),
            {
              ioverlayformatid_fk: stream.ioverlayformatid_fk,
              ioverlayon: enable,
              overlaysponsorid: sponsor_id
            }
          );
        },

        getLeagueWatermarkImages(leagueId) {
          const queryUrl = window.location.api("/broadcastManager/watermarkImages?league_id=" + leagueId);
          return $http.get(queryUrl);
        },

        getTeamSponsorImages(teamId) {
          const queryUrl = window.location.api("/broadcastManager/sponsor_images?team_id=" + teamId);
          return $http.get(queryUrl);
        }
      }
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/admin/broadcastManager/broadcastManagerService.js